import moment from 'moment';

const strings = require('../locales/activity/de.json');
import _ from 'lodash';

// const language = window.navigator.userLanguage || window.navigator.language;
// moment.locale(language)
moment.locale('de');

export const getLocalizedActivityStrings = activity => {
  const extraInfo = {};

  if (
    typeof activity.communication_type !== 'undefined' &&
    activity.communication_type !== 'none' &&
    activity.communication_type !== null &&
    typeof strings[activity.communication_type] !== 'undefined'
  ) {
    extraInfo.communication = strings[activity.communication_type];
  } else {
    extraInfo.communication = '';
  }

  extraInfo.communication_direction =
    activity.communication_direction !== 'undefined' &&
    activity.communication_direction !== 'none' &&
    activity.communication_direction !== null &&
    activity.communication_type !== 'other'
      ? `(${
          strings[
            `${activity.communication_type}_${activity.communication_direction}`
          ]
        })`
      : '';

  const start = moment(activity.start_time);
  const end = moment(activity.end_time);

  extraInfo.startDateValid = start.isValid();

  extraInfo.startDateObject = start.toDate();
  extraInfo.startDate = start.format('DD.MM.YYYY');
  extraInfo.startDateFull = start.format('dddd, DD. MMMM YYYY');
  extraInfo.startTime = start.format('HH:mm');

  if (end.isValid()) {
    extraInfo.endDateObject = end.toDate();
    extraInfo.endDate = end.format('DD.MM.YYYY');
    extraInfo.endTime = end.format('HH:mm');
    extraInfo.endDateFull = end.format('dddd, DD. MMMM YYYY');
  } else {
    extraInfo.endDateObject = null;
    extraInfo.endDate = null;
    extraInfo.endTime = null;
    extraInfo.endDateFull = null;
  }

  if (__TEST__) {
    const dateStart = moment('2010-06-09T15:20:00Z');
    const dateEnd = moment('2010-06-09T17:20:00Z');
    extraInfo.startDateObject = dateStart.toDate();
    extraInfo.endDateObject = dateEnd.toDate();
  }

  extraInfo.sameDay = start.diff(end, 'days') === 0;
  extraInfo.durationInMinutes = end.diff(start, 'minutes');
  extraInfo.durationInHours = end.diff(start, 'hours');
  extraInfo.durationInDays = end.diff(start, 'days');

  extraInfo.cost = 0;

  if (
    activity.serviceType !== null &&
    typeof activity.serviceType !== 'undefined'
  ) {
    let minutesToCalculate = extraInfo.durationInMinutes;

    if (minutesToCalculate !== 0 && activity.serviceType.rounding !== 0) {
      let surplus = extraInfo.durationInMinutes % activity.serviceType.rounding;

      if (surplus !== 0) {
        minutesToCalculate =
          minutesToCalculate - surplus + activity.serviceType.rounding;
      }
    }

    extraInfo.minutesToCalculate = minutesToCalculate;
    extraInfo.cost =
      (extraInfo.minutesToCalculate / 60) * activity.serviceType.hourly_rate;
  }

  if (
    extraInfo.communication_direction.length > 0 &&
    extraInfo.communication.length
  ) {
    extraInfo.communicationString = `${extraInfo.communication} ${extraInfo.communication_direction}`;
  } else if (extraInfo.communication.length) {
    extraInfo.communicationString = extraInfo.communication;
  } else {
    extraInfo.communicationString = null;
  }

  return extraInfo;
};

export const communicationTypes = [
  {
    value: 'none',
    label: 'keine',
  },
  {
    value: 'tel',
    label: 'Telefon',
    in: 'eingehend',
    out: 'ausgehend',
  },
  {
    value: 'fax',
    label: 'Fax',
    in: 'eingehend',
    out: 'ausgehend',
  },
  {
    value: 'email',
    label: 'E-Mail',
    in: 'eingehend',
    out: 'ausgehend',
  },
  {
    value: 'meeting',
    label: 'Meeting',
    in: 'intern',
    out: 'extern',
  },
  {
    value: 'training',
    label: 'Schulung',
    in: 'intern',
    out: 'extern',
  },
  {
    value: 'letter',
    label: 'Brief',
    in: 'eingehend',
    out: 'ausgehend',
  },
  {
    value: 'conference',
    label: 'Telefonkonferenz',
    in: 'eingehend',
    out: 'ausgehend',
  },
  {
    value: 'other',
    label: 'Sonstige',
  },
];

export const getCommunicationTypeDetails = communicationType => {
  return _.find(communicationTypes, { value: communicationType });
};

export default getLocalizedActivityStrings;



// WEBPACK FOOTER //
// ./src/models/Activity.js